import { closest } from '@utils/domUtils';

import Validator from './validations/Validator';
import * as validations from './validations/index';

/* global Swal */

export default class Validations {
  init() {
    this.beforeUnload = this.beforeUnload.bind(this);
    this.skipValidation = this.skipValidation.bind(this);
    this.validateForm = this.validateForm.bind(this);

    [...Object.keys(validations)].forEach(actionIdentifier => {
      [...document.querySelectorAll(`[data-validate="${actionIdentifier}"]`)].forEach(element => {
        const skipAction = element.querySelector('[data-skip-validation]');
        if (skipAction) {
          skipAction.addEventListener('click', this.skipValidation);
        }

        if (String(element.nodeName).toLowerCase() === 'form') {
          element.addEventListener('submit', this.validateForm);
        } else {
          const actionFunction = validations[element.getAttribute('data-validate')];
          if (actionFunction) {
            actionFunction(element);
          }
        }

        if (element.getAttribute('data-beforeunload') === 'true') {
          window.removeEventListener('beforeunload', this.beforeUnload);
          window.addEventListener('beforeunload', this.beforeUnload);
        }
      });

      [...document.querySelectorAll(`[data-skip-beforeunload="true"]`)].forEach(element => {
        if (String(element.nodeName).toLowerCase() === 'form') {
          element.addEventListener('submit', () =>
            window.removeEventListener('beforeunload', this.beforeUnload),
          );
        } else {
          element.addEventListener('click', () =>
            window.removeEventListener('beforeunload', this.beforeUnload),
          );
          element.addEventListener(
            'click',
            () => window.removeEventListener('beforeunload', this.beforeUnload),
            true,
          );
        }
      });
    });
  }

  skipValidation(event) {
    const form = closest(event.currentTarget, 'form');

    if (form) {
      form.setAttribute('data-validated', 'true');
    }
  }

  async validateForm(event) {
    const form = event.currentTarget;

    if (form.getAttribute('data-validated') === 'true') {
      return true;
    }

    if (form._validator) {
      event.preventDefault();
      return await this.validateFormWithValidator(event, form);
    }

    const actionIdentifier = form.getAttribute('data-validate');
    const actionFunction = validations[actionIdentifier];

    if (actionFunction) {
      event.preventDefault();

      const result = actionFunction(form);

      if (result === true) {
        this.setValidationStatus(event, true);
      } else if (result === false) {
        this.setValidationStatus(event, false);
      } else if (result instanceof Validator || (typeof result === 'object' && !!result.validate)) {
        // NOTE: if is validator instance, or at least an object that contains function `validate()`
        // -> assume we have a validator
        // -> store validator instance and call validation
        form._validator = result;
        return await this.validateFormWithValidator(event, form);
      } else if (result instanceof Promise) {
        const isValid = await result;
        this.setValidationStatus(event, isValid);
      }
    }
  }

  async validateFormWithValidator(event, form) {
    const validatorResult = await form._validator.validate();
    return this.setValidationStatus(event, validatorResult === 'Valid');
  }

  setValidationStatus(event, isValid) {
    if (isValid) {
      window.removeEventListener('beforeunload', this.beforeUnload);

      (event.currentTarget || event.target).setAttribute('data-validated', 'true');
      (event.currentTarget || event.target).submit();
      return true;
    }

    Swal.fire({
      text: 'Die eingegebenen Daten sind unvollständig. Bitte überprüfen Sie Ihre Angaben.',
      icon: 'error',
      buttonsStyling: false,
      confirmButtonText: 'Verstanden',
      customClass: {
        confirmButton: 'btn font-weight-bold btn-light',
      },
    });

    return isValid;
  }

  beforeUnload(event) {
    event.preventDefault();

    event.returnValue =
      'Sind Sie sicher, dass Sie diese Seite verlassen möchten? Ihr Arbeitsfortschritt geht dadurch verloren';

    return event.returnValue;
  }
}
